import { render, staticRenderFns } from "./InformacionGeneralForm.vue?vue&type=template&id=32ebacf8&scoped=true&"
import script from "./InformacionGeneralForm.vue?vue&type=script&lang=ts&"
export * from "./InformacionGeneralForm.vue?vue&type=script&lang=ts&"
import style0 from "./InformacionGeneralForm.vue?vue&type=style&index=0&id=32ebacf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32ebacf8",
  null
  
)

export default component.exports